import {
  List,
  TextField,
  EditButton,
  ShowButton,
  SimpleList,
  Datagrid,
  TopToolbar,
  CreateButton,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
  ReferenceField,
} from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { settings } from "app";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { TechnicalEquipmentExporter } from "./XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { administrationRequests } from "api/administrationApi";
import { MobileListRow } from "features/MobileListRow";

const ListTechnicalEquipmentTypes = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={TechnicalEquipmentExporter} />
      </TopToolbar>
    );
  };
  const filterTechnicalEquipment = [
    <TextInput
      source="name"
      label="Име"
      alwaysOn
    />,
    <TextInput
      source="manufacturer"
      label="Производител"
      alwaysOn
    />,
    <TextInput
      source="inventoryNumber"
      label="Инвентарен номер"
      alwaysOn
    />,
    <ReferenceInput
      source="departmentId"
      reference={administrationRequests.getDepartmentsSelect()}
      filter={{ filterByUser: true }}
      alwaysOn
    >
      <AutocompleteInput
        fullWidth
        label="Катедра"
        filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
        style={{ width: 300 }}
      />
    </ReferenceInput>,
  ];

  return (
    <List
      title="Технически оборудвания"
      sx={settings.style.expandStyle}
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateTechnicalEquipment)} />}
      filters={filterTechnicalEquipment}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Име", value: record.nameBg }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Модел", value: record.model }]} />
              <MobileListRow fields={[{ label: "Производител", value: record.manufacturer }]} />
              <MobileListRow fields={[{ label: "Сериен номер", value: record.serialNumber }]} />
              <MobileListRow fields={[{ label: "Инвентарен номер", value: record.inventoryNumber }]} />
              <MobileListRow fields={[{ label: "Описание", value: record.description }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Катедра",
                    value: (
                      <ReferenceField
                        source="departmentId"
                        reference={administrationRequests.getDepartmentsSelect()}
                      >
                        <TextField source="fullName" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={record => (
            <>
              {checkPermission(userPermissions, permissions.canUpdateTechnicalEquipment) && <EditButton label="" />}
              <ShowButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={settings.style.firstExpandIconDatagrid}
        >
          <TextField
            source="nameBg"
            label="Име"
            sortable={false}
          />
          <TextField
            label="Модел"
            source="model"
            sortable={false}
          />
          <TextField
            label="Производител"
            source="manufacturer"
            sortable={false}
          />
          <TextField
            label="Сериен номер"
            source="serialNumber"
            sortable={false}
          />
          <TextField
            label="Инвентарен номер"
            source="inventoryNumber"
            sortable={false}
          />
          <TextField
            label="Описание"
            source="description"
            sortable={false}
          />
          <ReferenceField
            label="Катедра"
            source="departmentId"
            reference={administrationRequests.getDepartmentsSelect()}
          >
            <TextField source="fullName" />
          </ReferenceField>
          {checkPermission(userPermissions, permissions.canUpdateTechnicalEquipment) && <EditButton />}
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};
export default ListTechnicalEquipmentTypes;
